<!--
 * @Description: 风险评测规则组件
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-22 18:29:48
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div v-if="showRuleComp" class="bizcomp-risk-rule">
        <el-dialog
            class="el-dialog-contain prop"
            :visible.sync="visible"
            width="60%"
            :before-close="checkDialogClose"
        >
            <template slot="title">
                <div class="el-dialog-my-title">
                    <span class="title-content1">投资者适当性匹配规则</span>
                    <span class="title-content3">来源： {{ $const.COMPANY }}基金</span>
                </div>
            </template>
            <div class="risk-user-level-text">
                根据普通投资者的风险测评结果，普通投资者按照风险承受能力由低到高可分为
                {{ matchedGrade }}种类型。
            </div>
            <div class="risk-user-level-info">
                <el-row>
                    <el-col class="risk-user-level-e">
                        <div
                            v-for="(item, index) of riskLevelArr"
                            :key="index"
                            class="flex-1 background-f9f9f9"
                        >
                            {{ "C" + item.subitem }}
                        </div>
                    </el-col>
                    <el-col class="risk-user-level-c">
                        <div v-for="(item, index) of riskLevelArr" :key="index" class="flex-1">
                            {{ item.subitemname }}
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="risk-user-level-text">
                根据投资者适当性匹配规则，不同风险承受能力投资者适合投资的产品或服务风险等级对应如下：
            </div>
            <div>
                <el-row>
                    <el-col class="risk-user-product">
                        <div class="flex-1 background-f9f9f9">普通投资者类型</div>
                        <div class="flex-2 background-f9f9f9">适合投资的产品或服务风险等级</div>
                    </el-col>
                    <el-col
                        v-for="(item, index) of riskLevelArr"
                        :key="index"
                        class="risk-user-product"
                    >
                        <div class="flex-1">{{ item.subitemname }}</div>
                        <div class="flex-2">{{ item.subitemProduct }}</div>
                    </el-col>
                    <!-- <el-col class="risk-user-product">
                        <div class="flex-1">保守型</div>
                        <div class="flex-2">低风险</div>
                    </el-col>
                    <el-col class="risk-user-product">
                        <div class="flex-1">谨慎型</div>
                        <div class="flex-2">低风险</div>
                    </el-col>
                    <el-col class="risk-user-product">
                        <div class="flex-1">稳健偏谨慎型</div>
                        <div class="flex-2">低风险、中低风险</div>
                    </el-col>
                    <el-col class="risk-user-product">
                        <div class="flex-1">稳健型</div>
                        <div class="flex-2">低风险、中低风险、中风险</div>
                    </el-col>
                    <el-col class="risk-user-product">
                        <div class="flex-1">稳健偏进取型</div>
                        <div class="flex-2">低风险、中低风险、中风险、中高风险</div>
                    </el-col>
                    <el-col class="risk-user-product">
                        <div class="flex-1">进取型</div>
                        <div class="flex-2">低风险、中低风险、中风险、中高风险、高风险</div>
                    </el-col> -->
                </el-row>
            </div>
            <div class="btn-contain">
                <button class="ok-btn" v-on:click="checkDialogClose">我知道了</button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";

export default {
    name: "RiskRule",
    mixins: [mixin],
    props: {
        showRuleComp: {
            type: Boolean,
            default: false
        },
        riskInfo: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visible: false,
            riskLevelArr: [],
            matchedGrade: ""
        };
    },
    computed: {},
    watch: {
        showRuleComp(value) {
            this.riskLevelArr = this.riskInfo;
            this.riskLevelArr.forEach((item) => {
                item.subitem = item.tit;
                item.subitemname = `${this.$cache.getDict("100017", item.subitem)}`;
                item.subitemProduct = this.getMatchedProduct(item.subitem);
            });
            this.matchedGrade = this.getMatchedGrade();
            this.visible = value;
        }
    },
    mounted() {
        // 风险匹配关系暂时写死
        // this.riskLevelArr = this.$cache.getDict("100017")
        //     ? this.$cache.getDict("100017")
        //     : [];
        // this.riskLevelArr.sort((a, b) => a.subitem - b.subitem);
        this.visible = this.showRuleComp;
    },
    methods: {
        checkDialogClose() {
            this.visible = false;
            this.$emit("dialog-close", false);
        },
        getMatchedGrade() {
            let res = "";
            this.riskLevelArr.forEach((item) => (res += "C" + item.subitem + "、"));
            res = res.substring(0, res.length - 1);
            res = `${res}${["零", "一", "二", "三", "四", "五", "六"][this.riskLevelArr.length]}`;
            return res;
        },
        getMatchedProduct(risklevel) {
            let productRisk = this.$cache.getDict("110143");
            let matchedRisk = productRisk.filter((item) => item.subitem <= risklevel);
            let res = "";
            matchedRisk.forEach((item) => (res += item.subitemname + "风险、"));
            return res.substring(0, res.length - 1);
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-risk-rule {
    .el-dialog-contain {
        border-radius: 6px;
        z-index: 2001;
        .el-dialog-my-title {
            display: flex;
            height: 50px;
            .title-content1 {
                margin-left: 20px;
                font-size: 20px;
                font-weight: 500;
                color: #333333;
                height: 50px;
                line-height: 50px;
            }
            .title-content2 {
                margin-left: 8px;
                font-size: 14px;
                font-weight: normal;
                color: #999999;
                height: 50px;
                line-height: 51px;
            }
            .title-content3 {
                margin-left: 8px;
                font-size: 14px;
                font-weight: normal;
                color: #999999;
                height: 50px;
                line-height: 50px;
            }
        }
        .risk-user-level-text {
            font-size: 14px;
            font-weight: normal;
            color: #333333;
            margin: 40px 33px 17px;
        }
        .risk-user-level-e,
        .risk-user-level-c,
        .risk-user-product {
            padding: 0 35px 0 33px;
            height: 50px;
            display: flex;
            left: 33px;
            align-items: center;
            font-size: 14px;
            font-weight: normal;
            color: #333333;
        }
        .flex-1 {
            flex: 1;
            padding-left: 18.14px;
            height: 50px;
            line-height: 50px;
            border: 1px solid #f1f1f1;
        }
        .flex-2 {
            flex: 2;
            padding-left: 64.11px;
            height: 50px;
            line-height: 50px;
            border: 1px solid #f1f1f1;
        }
        .background-f9f9f9 {
            background-color: #f9f9f9;
        }
        .btn-contain {
            margin-top: 39px;
            padding-bottom: 50px;
            text-align: center;
            .ok-btn {
                width: 180px;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                background: #e60012;
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
                border: none;
                cursor: pointer;
            }
        }
    }
    :deep(.el-dialog__body) {
        padding: 0;
    }
    :deep(.el-dialog__header) {
        height: 50px;
        border-radius: 6px 6px 0px 0px;
        background: #eeeeee;
        box-sizing: border-box;
        padding: 0;
        position: relative;
        .el-dialog__title {
            position: absolute;
            font-size: 18px;
            font-weight: bold;
            color: #333333;
            margin: 17px 20px 13px !important;
        }
        .el-dialog__headerbtn {
            position: absolute;
            top: 15px !important;
            right: 20px !important;
            width: 19.99px;
            height: 19.99px;
            background: #eeeeee;
            border: 1px solid #999999;
            box-sizing: border-box;
        }
        .el-dialog__headerbtn:hover {
            border: 1px solid #f61c14;
        }
        .el-icon-close {
            color: #999999;
        }
        .el-icon-close:before {
            color: #999999;
            font-size: 18px;
        }
        .el-icon-close:hover:before {
            color: #f61c14 !important;
        }
    }
    :deep(.el-dialog__footer) {
        .dialog-footer {
            display: flex;
            justify-content: center;
        }
        .el-button--default {
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: #e4e4e4;
            font-size: 16px;
            color: #666666;
        }
        .el-button--primary {
            width: 180px;
            border-radius: 2px;
            background: #e60012;
            font-size: 16px;
            font-weight: 500;
            color: #ffffff;
        }
    }
    .margin-left-40 {
        margin-left: 40px;
    }
}
</style>
